/** No 0/O or 1/I, so a name read aloud or typed from a screenshot is not misread. */
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const RANDOM_LENGTH = 5;

/** Up to three capital initials from a business or person name; "AD" when there are no letters. */
export function initialsOf(name: string | undefined | null) {
  const words = String(name ?? '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);
  const letters = words
    .slice(0, 3)
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  return letters || 'AD';
}

function randomCode(length: number) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => ALPHABET[byte % ALPHABET.length]).join('');
}

/**
 * A campaign name that identifies itself: `<business initials>-<YYMMDD>-<random>`, for example
 * `AV-261029-K7X2Q`. The date places it in time and the random part keeps it unique. The business is
 * the first name given: brand, company, then the person booking. The backend builds names the same
 * way for campaigns made elsewhere (for example the mobile app).
 */
export function buildCampaignName(parts: { brand?: string; company?: string; ownerName?: string; date?: Date }) {
  const business = [parts.brand, parts.company, parts.ownerName].find((value) => String(value ?? '').trim());
  const date = parts.date ?? new Date();
  const yy = String(date.getFullYear()).slice(-2);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${initialsOf(business)}-${yy}${mm}${dd}-${randomCode(RANDOM_LENGTH)}`;
}
